export function normalizeClozeText(text: string): string {
  return text.replace(/\{\{(c[1-9]\d*):(?!:)([^{}]+)\}\}/g, '{{$1::$2}}');
}

export function clozeEditError(text: string): string | null {
  const matches = normalizeClozeText(text).matchAll(/\{\{c[1-9]\d*::([^{}]+)\}\}/g);
  for (const match of matches) {
    if (match[1].split('::', 1)[0].trim()) return null;
  }
  return 'Keep at least one cloze answer, such as {{c1::answer}}, before saving.';
}

export function lectureFileError(file: Pick<File, 'name' | 'size'>): string | null {
  if (!/\.(pdf|ppt|pptx)$/i.test(file.name)) return 'Please choose a PDF or PowerPoint file.';
  if (file.size === 0) return 'This file is empty. Download or save a complete copy, then select it again.';
  if (file.size > 50 * 1024 * 1024) return 'File is too large. The maximum size is 50 MB.';
  return null;
}

export function isGenerationLimitError(error: unknown): boolean {
  return error instanceof Error && /monthly lecture limit reached/i.test(error.message);
}
